import ExpandCards, { IExpandCardsOuterProps } from 'core/components/common/ExpandCards';
import React from 'react';
import { GetPrivateProductDetailDataQuery } from 'site/graphql';

export const ExpandCardsWebinar = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<
        GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['webinars'][0] & { day: number }
    >
>;

export const ExpandCardsSeminar = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<
        GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['seminars'][0] & { day: number }
    >
>;

export const ExpandCardsMaterial = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['materials'][0]>
>;

export const ExpandCardsCertificate = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['certificates'][0]>
>;

export const ExpandCardsVideoCourse = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['videoCourses'][0]>
>;

export const ExpandCardsEventRecord = ExpandCards as React.ComponentType<
    IExpandCardsOuterProps<GetPrivateProductDetailDataQuery['purchasedProduct']['productForms'][0]['records'][0]>
>;
